<template>
   <div class="load-input">
      <span class='title'>Type</span>
      <span class='title'>Number</span>
      <span class='title'>Avg Load(W)</span>
      <label>{{ loadInfo.institution.type }}</label>
      <atom-input
         v-model="numberProxy"
         type="number"
         width="100"
      />
      <atom-input
         v-model="avgLoadProxy"
         type="number"
         step="0.001"
         width="100"
      />
   </div>
</template>

<script>
import AtomInput from '@/components/atoms/Login/Input';

export default {
   name: "load-input",
   components: {
      AtomInput,
   },
   props: {
      loadInfo: {
         type: Object,
         required: true,
         validator: loadInfo => ["avg_load_W","institution","number"].every(attr => Object.keys(loadInfo).includes(attr))
      }
   },
   computed: {
      numberProxy: {
         get()
         {
            return this.loadInfo.number;
         },
         set(newValue)
         {
            this.$emit('input', {...this.loadInfo, number: newValue});
         }
      },
      avgLoadProxy: {
         get()
         {
            return this.loadInfo.avg_load_W;
         },
         set(newValue)
         {
            this.$emit('input', {...this.loadInfo,avg_load_W: newValue});
         }
      }
   }
}
</script>

<style lang="scss" scoped>
.load-input {
   span.title {
      &:first-child {
         text-align: right;
         padding: 0 1em;
      }
      font-size: 0.9em;
      font-weight: 600;
      margin: 0;
      padding: 0;
   }
   &:not(:first-child) span.title {
      display: none;
   }
   display: grid;
   grid-template-columns: 4fr 5fr 5fr;
   grid-gap: 1em;
   color: $font-color;
   margin: 0.3em 0;
   label {
      font-weight: 600;
      text-align: right;
      word-break: break-word;
      margin-top: 0.5em;
      flex-basis: 50%;
      font-size: 0.85em;
   }
   > * {
      height: max-content;
   }
}

</style>